import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { cn } from "@/lib/utils";
function CurationByEraConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full animate-pulse rounded-xl bg-muted" />)}
      </div>;
  }
  if (error) {
    return null;
  }
  if (!terms || terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} className="group block h-full" data-index={i}>
          <Card className="relative h-full overflow-hidden border-border bg-transparent shadow-none transition-all duration-500 hover:shadow-none">
            <div className="relative aspect-[3/4] w-full overflow-hidden rounded-t-md bg-muted">
              {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  <span className="text-sm font-medium">No Image</span>
                </div>}
              {}
              <div className="absolute inset-0 bg-black/10 transition-opacity group-hover:opacity-0" />
            </div>
            
            <CardContent className="relative z-10 -mt-16 px-4 pb-4">
              <div className="bg-muted shadow-sm border border-border/50 p-6 text-center rounded-sm transition-transform duration-300 group-hover:-translate-y-1 group-hover:shadow-md">
                <h3 className="font-serif text-xl font-semibold text-foreground mb-2">
                  {term.name}
                </h3>
                <p className="text-sm text-muted-foreground line-clamp-2 font-sans">
                  {term.description || `Discover authentic pieces from the ${term.name} period, curated for their historical significance.`}
                </p>
              </div>
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function CurationByEra() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 4,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="curation-by-era" className="bg-background py-24">
      <div className="mx-auto max-w-7xl px-8">
        <div className="mb-16 text-center">
          <h2 className="mb-4 font-serif text-4xl font-bold text-foreground md:text-5xl">
            Curation by Era
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground font-sans">
            Explore our collection through the lens of history, featuring distinct periods of artistic excellence and craftsmanship.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CurationByEraConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}